









































































































import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator';
import { onKeyStroke } from '@vueuse/core';
import { Portal } from 'portal-vue';
import { FocusTrap } from 'focus-trap-vue';

import type { Image } from '@/graphql/generated';
import LockBodyScrollMixin from '@/mixins/lock-body-scroll';
import { IconClose, IconArrowRight, IconArrowLeft, IconEllipsisV, IconImport } from '@/icons';

@Component({
  components: {
    Portal,
    IconClose,
    IconArrowRight,
    IconArrowLeft,
    IconEllipsisV,
    IconImport,
    FocusTrap,
  },
})
export default class ModalImageGallery extends mixins(LockBodyScrollMixin) {
  @Prop({ type: [Boolean, Number] })
  open!: false | number

  @Prop({ type: String, required: true })
  labelledBy!: string

  // TODO: Add images type
  @Prop({ type: Array, required: true })
  images!: Partial<Image>[]

  focusIsTrapped = false;
  showMeta = true;
  highResImage: Partial<Image> = null;

  get componentId () {
    return this._uid;
  }

  get activeImage () {
    if (!this.open)
      return null;

    const lowResImage = this.images[this.open - 1];
    if (this.highResImage)
      return this.highResImage;
    else
      return lowResImage;
  }

  get metadata () {
    const image = this.activeImage;
    const meta = [];
    if (!image)
      return meta;

    if (image.altText)
      meta.push({
        title: 'Beskrivning',
        content: image.altText,
      });

    if (image.author)
      meta.push({
        title: 'Fotograf',
        content: image.author,
      });

    if (image.copyright)
      meta.push({
        title: 'Copyright',
        content: image.copyright,
      });

    return meta;
  }

  get downloadUrl () {
    return this.activeImage?.downloadUrl;
  }

  // @Watch('metadata')
  // onMetadataChanged (metadata) {
  //   this.showMeta = metadata.length > 0;
  // }

  @Watch('open')
  whenOpenChanges (open) {
    if (!open)
      return;

    this.onOpen();
    this.highResImage = null;
    this.$nuxt.$loading.start();
  }

  onImageLoaded () {
    this.$nuxt.$loading.finish();
  }

  @Watch('$route')
  onRouteChange () {
    this.onClose();
  }

  mounted () {
    onKeyStroke('Escape', this.onClose);
  }

  changeCurrentImage (i: number) {
    this.$emit('update:open', i);
  }

  onOpen () {
    this.focusIsTrapped = true;
    this.lockScroll(true);
  }

  onClose () {
    this.focusIsTrapped = false;
    this.lockScroll(false);
    this.$emit('update:open', false);
  }

  toggleMeta () {
    this.showMeta = !this.showMeta;
  }

  prevImage () {
    if (this.open && typeof this.open === 'number') {
      const prevImageIndex = this.open === 1 ? this.images.length : this.open - 1;
      this.changeCurrentImage(prevImageIndex);
    }
  }

  nextImage () {
    if (this.open && typeof this.open === 'number') {
      const nextImageIndex = this.open === this.images.length ? 1 : this.open + 1;
      this.changeCurrentImage(nextImageIndex);
    }
  }

  navigate (increment: number) {
    if (!this.open)
      return null;

    const newImageIndex = this.open + increment;
    if (this.images[newImageIndex - 1])
      this.changeCurrentImage(newImageIndex);
  }
}
